/**
 * @flow
 * @format
 */

// import { downloadSVGImage } from '../utils';
// import { getNextFieldsByStep, getStepByField, downloadBlob, downloadSVGImage } from '../utils';
import { createAction } from 'redux-actions';

import { actions as modalActions, constants as modalConstants } from './modal';
import type { CurrentUserType } from './global';

export type DesignObjectResponseType = {
  id: number,
  recordName: string,
  recordType: string,
  timestamp: number,
  timeStampString: string,
  trackingId: string,
  userId: string,
};

export type DesignResponseType = {
  data: {
    [key: string]: any,
  },
  message: {
    type: 'SUCCESS' | 'ERROR',
  },
};

// Constants
export const constants = {
  STEP_FORWARD: 'Design/STEP_FORWARD',
  STEP_BACKWARD: 'Design/STEP_BACKWARD',
  STEP_RESET: 'Design/STEP_RESET',
  AUTO_COMPLETE: 'Design/AUTO_COMPLETE',
  RENAME_DESIGN: 'Design/RENAME_DESIGN',
  NEW_DESIGN: 'Design/NEW_DESIGN',
  ERROR: 'Design/ERROR',
  API_ERROR: 'Design/API_ERROR',
  EVALUATE_ERROR: 'Design/EVALULATE_ERROR',
  UPDATE: 'Design/UPDATE',
  EVALUATE: 'Design/EVALUATE',
  CHANGE_VALUE: 'Design/CHANGE_VALUE',
  REVERT_FIELD: 'Design/REVERT_FIELD',
  PENDING: 'Design/PENDING',
  VALIDATION_ERROR: 'Design/VALIDATION_ERROR',
  DOWNLOAD_PDF: 'Design/DOWNLOAD_PDF',
  REQUEST_PDF: 'Design/REQUEST_PDF',
  CANCEL_PDF: 'Design/CANCEL_PDF',
  RECEIVE_PDF: 'Design/RECEIVE_PDF',

  DOWNLOAD_SCHEMATIC: 'Design/DOWNLOAD_SCHEMATIC',

  CHECK_FET_CONFIG: 'Design/CHECK_FET_CONFIG',
  RECEIVE_FET_CONFIG: 'Design/RECEIVE_FET_CONFIG',

  EXPORT_BOM_EXCEL: 'Design/EXPORT_BOM_EXCEL',

  SAVE_DESIGN: 'Design/SAVE_DESIGN',
  OPEN_DESIGN: 'Design/OPEN_DESIGN',
  // FETCH_DESIGNS: 'Design/FETCH_DESIGNS',
  // RECEIVE_DESIGNS: 'Design/RECEIVE_DESIGNS',

  // FETCH_DESIGN: 'Design/FETCH_DESIGN',
  // RECEIVE_DESIGN: 'Design/RECEIVE_DESIGN',

  REQUEST_USER: 'Design/REQUEST_USER',
  RECEIVE_USER: 'Design/RECEIVE_USER',

  REQUEST_PARTS: 'Design/REQUEST_PARTS',
  RECEIVE_PARTS: 'Design/RECEIVE_PARTS',
};

export const revertField = createAction(
  constants.REVERT_FIELD,
  ({ id }: { id: string }) => ({ field: id }),
  ({ isSelect }: { isSelect: boolean }) => ({ isSelect }),
);

export type DesignActions = { type: $Keys<typeof constants> };
export type ActionFunctionType = () => {
  payload?: Object | string,
  type: $Keys<typeof constants>,
};

// Action Creators
export const actions = {
  revertField,
  stepForward: (): Action<null> => ({
    type: constants.STEP_FORWARD,
    payload: null,
  }),
  stepBackward: (): Action<null> => ({
    type: constants.STEP_BACKWARD,
    payload: null,
  }),
  stepReset: (): Action<null> => ({
    type: constants.STEP_RESET,
    payload: null,
  }),
  autoComplete: (): Action<null> => ({
    type: constants.AUTO_COMPLETE,
    payload: null,
  }),
  pendingAction: (): Action<null> => ({
    type: constants.PENDING,
    payload: null,
  }),
  renameDesign: (payload: {}) => ({
    type: constants.RENAME_DESIGN,
    data: payload,
  }),
  newDesign: (silent: boolean = false) => ({
    type: constants.NEW_DESIGN,
    payload: silent,
  }),

  error: (payload: {}) => ({ type: constants.ERROR, payload }),
  apiError: (payload: {}) => ({ type: constants.API_ERROR, payload }),
  evaluateError: (payload: {}) => ({ type: constants.EVALUATE_ERROR, payload }),
  receiveData: (payload: {}) => ({ type: constants.UPDATE, payload }),
  evaluateData: (payload: {}) => ({ type: constants.EVALUATE, payload }),
  validationError: (payload: {}) => ({
    type: constants.VALIDATION_ERROR,
    payload,
  }),
  changeValue: (payload: {}) => ({ type: constants.CHANGE_VALUE, payload }),

  // downloadPDF: () => ({ type: constants.DOWNLOAD_PDF }),
  requestPDF: () => ({ type: constants.REQUEST_PDF }),
  cancelPDF: () => ({ type: constants.CANCEL_PDF }),

  receivePDF: (payload: {}, filename: string) => ({
    type: constants.RECEIVE_PDF,
    payload,
    filename,
  }),

  requestUser: () => ({ type: constants.REQUEST_USER }),
  receiveUser: (payload: CurrentUserType) => ({
    type: constants.RECEIVE_USER,
    payload,
  }),

  downloadSchematic: () => ({ type: constants.DOWNLOAD_SCHEMATIC }),
  // saveSchematicImage: (data: string, filename: string) => downloadSVGImage(data, filename),

  checkFETConfig: () => ({ type: constants.CHECK_FET_CONFIG }),
  receiveFETConfig: (payload: [boolean, boolean, boolean]) => ({
    type: constants.RECEIVE_FET_CONFIG,
    payload,
  }),

  exportBOMToExcel: () => ({ type: constants.EXPORT_BOM_EXCEL }),

  saveDesign: (payload: string) => ({ type: constants.SAVE_DESIGN, payload }),
  openDesign: () => ({ type: constants.OPEN_DESIGN }),

  // fetchDesign: (payload: number) => ({ type: constants.FETCH_DESIGN, payload }),
  // receiveDesign: (payload: Object) => ({
  //   type: constants.RECEIVE_DESIGN,
  //   payload,
  // }),
  // fetchDesigns: () => ({ type: constants.FETCH_DESIGNS }),
  receiveDesigns: (data?: Object) =>
    modalActions.showModal({
      modalType: modalConstants.MODAL_OPEN_DESIGN,
      modalProps: {
        data,
        // onOpenDesign: (id: number) => dispatch(actions.fetchDesign(id)),
      },
    }),
  requestParts: () => ({ type: constants.REQUEST_PARTS }),
  receiveParts: (payload: { [key: string]: string }) => ({
    type: constants.RECEIVE_PARTS,
    payload,
  }),
};

export type SchematicType = {
  data: string,
  hasData: boolean,
  loading: boolean,
};

export type ReportType = {
  data: string,
  hasData: boolean,
  loading: boolean,
};

type RangeType = {
  max: number,
  min: number,
};

export type FieldDataType = {
  currentValue?: any,
  defaultValue?: any,
  hasRangeValue?: boolean,
  hasSelectionValue?: boolean,
  rangeValue?: RangeType,
  selectionValue?: number,
  step?: string,
};

export type RecordDataType = {
  id: number,
  recordName: string,
  trackingId: string,
};

type ValT = (string | number) | (number | string)[] | string[][];
type FieldVT = {
  currentValue: ValT,
  defaultValue: ValT,
  rangeValue: { min: number, max: number },
};

export type DesignState = {
  changedFields: { [key: string]: boolean },
  currentStep: string,
  dirtyFields: { [key: string]: boolean },
  errors: { [key: string]: Array<string> },
  evaluating: { [key: string]: boolean },
  fields: Object,
  id: ?string,
  info: { [key: string]: Array<string> },
  initialValues: { [key: string]: FieldVT },
  loading: boolean,
  name: string,
  openingDesign: boolean,
  report: ReportType,
  savingDesign: boolean,
  schematic: SchematicType,
  stepStatus: any,
  values: { [key: string]: FieldVT },
};

export default { constants, actions };



// WEBPACK FOOTER //
// ./src/actions/design.js